<template>
    <div class="com-codics-ui-upload-ddax-body">
        <div ref="myUpload2" :style="{ '--size': size }">
            <div class="com-codics-ui-upload-ddax-item" v-for="(item, index) in value"
                :key="isImage ? item : item?.himg">
                <img v-show="isImage" class="com-codics-ui-upload-ddax-item-img" :src="action + item"
                    :style="{ 'object-fit': fit }">
                <img v-show="accept.indexOf('video') != -1" class="com-codics-ui-upload-ddax-item-img" :src="item.himg"
                    :style="{ 'object-fit': fit }">
                <div class="com-codics-ui-upload-ddax-item-btn-box" style="max-width: 80px;">
                    <div v-show="prev" class="com-codics-ui-upload-ddax-item-btn iconfonts" @click="changeIndex(index)"
                        v-html="isImage ? '&#xe87d;' : '&#xe7c1;'"></div>
                    <div v-show="del" class="com-codics-ui-upload-ddax-item-btn iconfonts" @click="handleRemove(item)">
                        &#xe850;</div>
                    <div v-show="down" class="com-codics-ui-upload-ddax-item-btn iconfonts"
                        @click="downloadByLink(isImage ? (action + item) : (action + item.video), (isImage ? item : item.video).match(/\/([^\/]+?)/))">
                        &#xe854;</div>
                </div>
            </div>
        </div>
        <el-upload class="com-codics-ui-upload-ddax-up-box" ref="myUpload" action="cdn.bosscaigou.com" :accept="accept"
            :http-request="uploadData" :multiple="multiple || limit > 1" :show-file-list="false">
            <div class="com-codics-ui-upload-ddax-up" :style="{ '--size': size }" v-if="value.length < limit"></div>
        </el-upload>
        <div class="com-codics-ui-upload-ddax-zz"
            :style="{ 'opacity': zzState ? 1 : 0, 'visibility': zzState ? 'visible' : 'hidden' }" v-show="zzState">
            <el-carousel v-show="isImage" height="100%" style="height:100%;" :autoplay="false" ref="myCarousel">
                <el-carousel-item v-for="(item, index) in value" :key="index">
                    <img class="com-codics-ui-upload-ddax-item-img" :src="action + item"
                        :style="{ 'object-fit': 'contain' }">
                </el-carousel-item>
            </el-carousel>
            <video v-show="accept.indexOf('video') != -1" ref="videoPlayer"
                class="com-codics-ui-upload-ddax-zz-video video-js" controls preload="auto" width="100%" height="100%">
                <source :src="value[0]?.video" type="video/mp4">
            </video>
            <div class="com-codics-ui-upload-ddax-zz-close" @click="closeZZ();"></div>
        </div>
    </div>
</template>

<script>

import { getQiNiuToken } from '@/api';
import Sortable from 'sortablejs';
import * as qiniu from 'qiniu-js';
// 引入随机字符串库
import { v4 as uuid } from 'uuid';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { size } from 'lodash';
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        prev: {
            type: Boolean,
            default: true
        },
        del: {
            type: Boolean,
            default: true
        },
        sort: {
            type: Boolean,
            default: true
        },
        fit: {
            type: String,
            default: 'cover'
        },
        action: {
            type: String,
            default: 'https://cdn.bosscaigou.com/'
        },
        limit: {
            type: Number,
            default: 1
        },
        size: {
            type: String,
            default: '148px'
        },
        accept: {
            type: String,
            default: '*/image'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        down: {
            type: Boolean,
            default: false
        },
        bf: {
            type: Function,
            default: (done, uploadInfo, qiNiuInfo) => {
                done(uploadInfo);
            }
        },
        handle: {
            type: Function,
            default: (uploadInfo, done) => {
                done(uploadInfo);
            }
        }
    },
    data() {
        return {
            qiNiuInfo: {
                token: ''
            },
            player: null,
            zzState: false
        }
    },
    mounted() {
        this.getTokenFuc();
        if (this.accept.indexOf('video') != -1) {
            this.player = videojs(this.$refs.videoPlayer);
        }
    },
    methods: {     // videoFile: 要解析的视频文件资源， time: 获取视频某一时刻的画面
        captureFrame(videoFile, time = 0, data) {
            let _that = this;
            return new Promise((resolve) => {
                // 因为dom节点没有渲染到浏览器，视频播放到指定的时间就会停止播放
                const videoElement = document.createElement('video');
                videoElement.currentTime = time; // 设置截取的帧时间
                // 自动播放存在兼容性问题，设置静音解决自动播放在不同浏览器的兼容性问题
                videoElement.muted = true;
                videoElement.autoplay = true;
                videoElement.src = URL.createObjectURL(videoFile);
                videoElement.oncanplay = async function () {
                    const flame = await _that.drawVideoToCanvas(videoElement);
                    data['himg'] = flame;
                    _that.blobToDataURI(flame, function (dataURI) {
                        data['himg'] = dataURI;
                        resolve(dataURI);
                    });
                };
            });
        },
        // blob 转 base64
        blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {
                callback(e.target.result);
            };
        },
        drawVideoToCanvas(video) {
            return new Promise((resolve) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                canvas.toBlob((blob) => {
                    resolve(blob);//URL.createObjectURL(blob)
                });
            });
        },
        closeZZ() {
            this.zzState = false;
            this.player && this.player.pause();
        },
        handleRemove(txt) {
            if (this.isImage) {
                this.$emit('input', this.value.filter(item => item.indexOf(txt) == -1));
            } else {
                this.$emit('input', this.value.filter(item => item.video.indexOf(txt.video) == -1));
            }
        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        downloadByLink(url, fileName) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => saveAs(blob, fileName));
        },
        getFileExtension(filename) {
            // 匹配最后一个点（.）后面的内容（兼容带路径的文件名）
            const regex = /(?:\.([^.]+))?$/;
            const match = regex.exec(filename);
            return match ? match[1].toLowerCase() : null; // 返回小写扩展名
        },
        uploadData(uploadInfo) {

            console.log(uploadInfo)

            const _that = this;

            this.bf(() => {

                this.handle(uploadInfo, (uploadInfo) => {

                    if (this.value.length >= this.limit) return;

                    console.log(uploadInfo)

                    const fileExtension = _that.getFileExtension(uploadInfo.file.name); // 获取文件扩展名

                    let data = {
                        himg: null
                    };

                    if (this.accept.indexOf('video') != -1) {

                        _that.captureFrame(uploadInfo.file, 0, data);

                    }

                    const loading = this.$loading({
                        lock: true,
                        text: '上传中(0%)...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    console.log(_that.$refs.myUpload2, _that.value)

                    _that.initDragSort(_that.$refs.myUpload2);

                    if (this.value.length >= this.limit) {
                        this.$message({
                            showClose: true,
                            message: '最多上传' + this.limit + '张图片！',
                            type: 'warning'
                        });
                        return;
                    }
                    // 上传文件
                    const observer = {
                        next(res) {
                            loading.text = '上传中(' + res.total.percent.toFixed(2) + "%)...";
                        },
                        error(err) {
                            console.log('上传出错：' + err)
                            loading.close();
                            _that.$message({
                                showClose: true,
                                message: '图片上传失败！',
                                type: 'danger'
                            });
                        },
                        complete(res) {
                            console.log(res.key)
                            if (_that.accept.indexOf('video') != -1) {
                                data['video'] = res.key;
                                _that.value.push(data);
                            } else {
                                _that.value.push(res.key);
                            }
                            loading.close();
                        }
                    };

                    const observable = qiniu.upload(uploadInfo.file, this.accept.indexOf('video') != -1 ? (`editor/video/${uuid()}_${new Date().getTime()}.${fileExtension}`) : (`editor/img/${uuid()}_${new Date().getTime()}.${fileExtension}`), this.qiNiuInfo.token, {}, {

                    });

                    const subscription = observable.subscribe(observer) // 上传开始
                    // subscription.unsubscribe() // 上传取消

                });

            }, uploadInfo, this.qiNiuInfo);

        },
        playVideo(url) {
            if (this.player) {
                this.player.src(url);
                this.player.play();
            }
        },
        initDragSort(el) {
            const _that = this;
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    let arr = _that.value;
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);
                }
            });
        },
        changeIndex(index) {
            this.zzState = true;
            if (this.accept.indexOf('video') != -1) {
                this.playVideo(this.action + this.value[index].video);
            } else {
                this.$refs.myCarousel.setActiveItem(index);
            }
        },
        pickImg() {
            const input = document.querySelector('.com-codics-ui-upload-ddax-up-box input[type="file"]');
            input && input.click();
        }
    },
    computed: {
        isImage() {
            return this.accept.indexOf('image') != -1 || this.accept.indexOf('png') != -1 || this.accept.indexOf('jpg') != -1 || this.accept.indexOf('jpeg') != -1 || this.accept.indexOf('gif') != -1;
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
}
</script>

<style>
.com-codics-ui-upload-ddax-body {
    height: fit-content;
    width: fit-content;
    max-width: 100%;
    /* overflow-x: scroll; */
    position: relative;
    float: left;
    box-sizing: border-box;
    display: flex;
    /* 启用弹性布局 */
    /* gap: 10px; */
    /* 可选：设置子元素间距 */
}

.com-codics-ui-upload-ddax-item {
    height: var(--size);
    width: var(--size);
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 5px;
    margin-right: 15px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #EBEBEB;
    transition: .3s;
}

.com-codics-ui-upload-ddax-item::before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.4);
    transition: .3s;
    opacity: 0;
    z-index: 2;
    backdrop-filter: blur(4px);
}

.com-codics-ui-upload-ddax-item:hover::before {
    opacity: 1;
}

.com-codics-ui-upload-ddax-item-img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-ui-upload-ddax-up {
    border: 1px dashed #d9d9d9;
    transition: .3s;
    height: var(--size);
    width: var(--size);
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
}

.com-codics-ui-upload-ddax-up::before,
.com-codics-ui-upload-ddax-up::after {
    content: '';
    height: 1px;
    width: 20px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    background: #999;
}

.com-codics-ui-upload-ddax-up::after {
    transform: rotate(90deg);
}

.com-codics-ui-upload-ddax-up:hover {
    border: 1px dashed #333;
}

.com-codics-ui-upload-ddax-up:active {
    border: 1px dashed #333;
}

.com-codics-ui-upload-ddax-item-btn-box {
    height: fit-content;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    z-index: 3;
}

.com-codics-ui-upload-ddax-item-btn {
    height: 40px;
    width: 40px;
    position: relative;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    color: #FFF;
    font-size: 16px;
    user-select: none;
    -webkit-user-drag: none;
    transition: .3s;
    opacity: 0;
}

.com-codics-ui-upload-ddax-item:hover .com-codics-ui-upload-ddax-item-btn {
    opacity: 1;
}

.com-codics-ui-upload-ddax-zz {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.65);
    transition: .3s;
}

.com-codics-ui-upload-ddax-zz-close {
    height: 40px;
    width: 40px;
    position: absolute;
    margin: auto;
    top: 20px;
    right: 20px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    transition: .3s;
    cursor: pointer;
    z-index: 22;
}

.com-codics-ui-upload-ddax-zz-close::before,
.com-codics-ui-upload-ddax-zz-close::after {
    content: '';
    height: 1px;
    width: 20px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    background: #333;
    transform: rotate(45deg);
}

.com-codics-ui-upload-ddax-zz-close::after {
    transform: rotate(-45deg);
}

.com-codics-ui-upload-ddax-zz-close:hover {
    background: #FFF;
}

.com-codics-ui-upload-ddax-zz-video {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}
</style>